import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import withOptions from 'utils/functions/withOptions.util';
import actionBe from 'utils/mw/actionBe.util';

const beTimeOffReport = actionBe(
  'beTimeOffReport',
  withOptions(({ AT, ATAG }) =>
    endpoint(H.get, 'salon/v2/:salonId/time_off_report/', {
      AT,
      name: ATAG,
    }),
  ),
);

// noinspection JSUnusedGlobalSymbols
export default beTimeOffReport;
